import Enumerator from '../global/Enumerator';

export const assetFinanceAssetTypes = [
  'none',
  'passenger_vehicle_pax9',
  'passenger_vehicle_taxi',
  'passenger_vehicle_hire',
  'light_commercial_t35',
  'light_commercial_t45',
  'light_commercial_t50',
  'light_commercial_t072',
  'truck',
  'prime_mover',
  'trailer_heavy',
  'trailer_light',
  'bus',
  'motorbike',
  'motorbike_on_road',
  'motorbike_off_road',
  'boats_motors_and_trailer_packages',
  'golf_carts',
  'caravan',
  'marine',
  'medical',
  'earthmoving',
  'materials_handling',
  'mining',
  'plant_and_equipment',
  'agriculture',
  'tractor',
  'manufacturing',
  'crane',
  'access_equipment',
  'forestry',
  'telephony',
  'it',
  'business_equipment',
  'gym',
  'solar_or_energy_efficient',
  'aircraft',
  'fit_out',
  'vending_machines',
  'poker_machines',
  'eeef',
  'unsecured',
  'cashflow',
  'non_standard'
];

export class AssetFinanceAssetType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'passenger_vehicle_pax9';
        break;
      case '2':
        correctOption = 'passenger_vehicle_taxi';
        break;
      case '3':
        correctOption = 'passenger_vehicle_hire';
        break;
      case '4':
        correctOption = 'light_commercial_t35';
        break;
      case '5':
        correctOption = 'light_commercial_t50';
        break;
      case '6':
        correctOption = 'light_commercial_t45';
        break;
      case '7':
        correctOption = 'light_commercial_t072';
        break;
      case '8':
        correctOption = 'truck';
        break;
      case '9':
        correctOption = 'prime_mover';
        break;
      case '10':
        correctOption = 'trailer_heavy';
        break;
      case '11':
        correctOption = 'trailer_light';
        break;
      case '12':
        correctOption = 'bus';
        break;
      case '13':
        correctOption = 'motorbike';
        break;
      case '14':
        correctOption = 'motorbike_on_road';
        break;
      case '15':
        correctOption = 'motorbike_off_road';
        break;
      case '16':
        correctOption = 'boats_motors_and_trailer_packages';
        break;
      case '17':
        correctOption = 'golf_carts';
        break;
      case '18':
        correctOption = 'caravan';
        break;
      case '19':
        correctOption = 'marine';
        break;
      case '20':
        correctOption = 'medical';
        break;
      case '21':
        correctOption = 'earthmoving';
        break;
      case '22':
        correctOption = 'materials_handling';
        break;
      case '23':
        correctOption = 'mining';
        break;
      case '24':
        correctOption = 'plant_and_equipment';
        break;
      case '25':
        correctOption = 'agriculture';
        break;
      case '26':
        correctOption = 'tractor';
        break;
      case '27':
        correctOption = 'manufacturing';
        break;
      case '28':
        correctOption = 'crane';
        break;
      case '29':
        correctOption = 'access_equipment';
        break;
      case '30':
        correctOption = 'forestry';
        break;
      case '31':
        correctOption = 'telephony';
        break;
      case '32':
        correctOption = 'it';
        break;
      case '33':
        correctOption = 'business_equipment';
        break;
      case '34':
        correctOption = 'gym';
        break;
      case '35':
        correctOption = 'solar_or_energy_efficient';
        break;
      case '36':
        correctOption = 'aircraft';
        break;
      case '37':
        correctOption = 'fit_out';
        break;
      case '38':
        correctOption = 'vending_machines';
        break;
      case '39':
        correctOption = 'poker_machines';
        break;
      case '40':
        correctOption = 'eeef';
        break;
      case '41':
        correctOption = 'unsecured';
        break;
      case '42':
        correctOption = 'cashflow';
        break;
      case '43':
        correctOption = 'non_standard';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

AssetFinanceAssetType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  passenger_vehicle_pax9: {
    get title() {
      return 'Passenger vehicle (up to 9 pax)';
    }
  },
  passenger_vehicle_taxi: {
    get title() {
      return 'Passenger vehicle (Taxi)';
    }
  },
  passenger_vehicle_hire: {
    get title() {
      return 'Passenger vehicle (hire car)';
    }
  },
  light_commercial_t35: {
    get title() {
      return 'Light commercial (up to 3.5t)';
    }
  },
  light_commercial_t45: {
    get title() {
      return 'Light commercial (up to 4.5t)';
    }
  },
  light_commercial_t50: {
    get title() {
      return 'Light commercial (up to 5.0t)';
    }
  },
  light_commercial_t072: {
    get title() {
      return 'Light commercial (up to 12.0t)';
    }
  },
  truck: {
    get title() {
      return 'Truck';
    }
  },
  prime_mover: {
    get title() {
      return 'Prime mover';
    }
  },
  trailer_heavy: {
    get title() {
      return 'Heavy trailer (truck towed)';
    }
  },
  trailer_light: {
    get title() {
      return 'Light trailer (car towed)';
    }
  },
  bus: {
    get title() {
      return 'Bus';
    }
  },
  motorbike: {
    get title() {
      return 'Motorbike';
    }
  },
  motorbike_on_road: {
    get title() {
      return 'Motorbike on road';
    }
  },
  motorbike_off_road: {
    get title() {
      return 'Motorbike off road';
    }
  },
  boats_motors_and_trailer_packages: {
    get title() {
      return 'Boats, motors and trailer packages';
    }
  },
  golf_carts: {
    get title() {
      return 'Golf carts';
    }
  },
  caravan: {
    get title() {
      return 'Caravan';
    }
  },
  marine: {
    get title() {
      return 'Marine';
    }
  },
  medical: {
    get title() {
      return 'Medical';
    }
  },
  earthmoving: {
    get title() {
      return 'Earthmoving (including Yellow Goods)';
    }
  },
  materials_handling: {
    get title() {
      return 'Materials handling';
    }
  },
  mining: {
    get title() {
      return 'Mining (including Yellow Goods)';
    }
  },
  plant_and_equipment: {
    get title() {
      return 'Plant and equipment';
    }
  },
  agriculture: {
    get title() {
      return 'Agriculture';
    }
  },
  tractor: {
    get title() {
      return 'Tractor';
    }
  },
  manufacturing: {
    get title() {
      return 'Manufacturing';
    }
  },
  crane: {
    get title() {
      return 'Crane';
    }
  },
  access_equipment: {
    get title() {
      return 'Access equipment';
    }
  },
  forestry: {
    get title() {
      return 'Forestry';
    }
  },
  telephony: {
    get title() {
      return 'Telephony';
    }
  },
  it: {
    get title() {
      return 'IT';
    }
  },
  business_equipment: {
    get title() {
      return 'Business equipment';
    }
  },
  gym: {
    get title() {
      return 'Gym';
    }
  },
  solar_or_energy_efficient: {
    get title() {
      return 'Solar/Energy efficient';
    }
  },
  aircraft: {
    get title() {
      return 'Aircraft';
    }
  },
  fit_out: {
    get title() {
      return 'Fit out';
    }
  },
  vending_machines: {
    get title() {
      return 'Vending machines';
    }
  },
  poker_machines: {
    get title() {
      return 'Poker machines';
    }
  },
  eeef: {
    get title() {
      return 'EEEF';
    }
  },
  unsecured: {
    get title() {
      return 'Unsecured';
    }
  },
  cashflow: {
    get title() {
      return 'Cashflow';
    }
  },
  non_standard: {
    get title() {
      return 'Non standard';
    }
  }
});

export default {
  assetFinanceAssetTypes,
  AssetFinanceAssetType
};
